import { apiUc as http } from '../../../../../http';

class DialerProcessService {
  call(data) {
    return http.post(`/api/processo-discador/call`, data);
  }

  next(data) {
    return http.post(`/api/processo-discador/next`, data);
  }
  redial(cdrDialerId) {
    return http.patch(`/api/processo-discador/${cdrDialerId}/rediscagem`, {});
  }
}

export default new DialerProcessService();
